/*
  Header menu hover intent (Two Seventy Nine).

  Prestige opens a header dropdown the instant the pointer touches its menu item, so sliding across
  the header (e.g. from "Couches" to "Shop all") flashes every menu in between. This waits for the
  pointer to rest on a CLOSED top-level menu item for the delay set in
  Theme settings > Header > "Dropdown hover delay" before opening it.

  It does not modify theme.js: it intercepts the first mouseover on a closed menu item (capture phase),
  then calls the theme's own public toggle(). Once a menu is open, every event passes through
  untouched, so the theme's close behaviour, keyboard and click handling are unchanged.
  Loaded only when the setting is above 0 and menus open on hover.
*/
(() => {
  const SELECTOR = 'mega-menu-disclosure[hover-delay], dropdown-menu-disclosure[hover-delay]';
  const pending = new WeakMap();
  const finePointer = window.matchMedia('screen and (pointer: fine)');

  const delayOf = (menu) => parseInt(menu.getAttribute('hover-delay'), 10) || 0;
  const isOpen = (menu) => Boolean(menu.disclosureElement?.open);

  const cancel = (menu) => {
    clearTimeout(pending.get(menu));
    pending.delete(menu);
  };

  const openAfterDelay = (menu) => {
    if (pending.has(menu)) return;
    pending.set(menu, setTimeout(() => {
      pending.delete(menu);
      if (!menu.matches(':hover')) return;
      // Close any other top-level menu first so two panels never overlap.
      document.querySelectorAll(SELECTOR).forEach((other) => {
        if (other !== menu && isOpen(other)) other.toggle(false);
      });
      menu.toggle(true);
    }, delayOf(menu)));
  };

  document.addEventListener('mouseover', (event) => {
    if (!finePointer.matches) return;
    const menu = event.target.closest?.(SELECTOR);
    if (!menu || menu.getAttribute('trigger') !== 'hover' || delayOf(menu) === 0 || isOpen(menu)) return;
    // Hold the event back from the theme's instant-open handler (and its hover-outside closer, so the
    // menu already open stays open until the new one actually opens).
    event.stopPropagation();
    openAfterDelay(menu);
  }, true);

  document.addEventListener('mouseout', (event) => {
    const menu = event.target.closest?.(SELECTOR);
    if (menu && !menu.contains(event.relatedTarget)) cancel(menu);
  }, true);
})();
